import { Misc } from '../';
var SortOperation = /** @class */ (function () {
    function SortOperation(column, sortAscending) {
        this.column = column;
        this.sortAscending = sortAscending;
    }
    SortOperation.fromPrevious = function (previousSort, column, sortAscending) {
        var propertyHasChanged = !previousSort || (column !== previousSort.column);
        var newSortAscending;
        if (sortAscending !== undefined) {
            newSortAscending = sortAscending;
        }
        else if (propertyHasChanged) {
            newSortAscending = this.getDefaultSortAscending(column);
        }
        else {
            newSortAscending = !previousSort.sortAscending;
        }
        return new SortOperation(column, newSortAscending);
    };
    SortOperation.getDefaultSortAscending = function (property) {
        return Misc.Settings.sortDescendingTypes.indexOf(property.propertyType) < 0;
    };
    return SortOperation;
}());
export { SortOperation };
